import type { CombinedContractListItem, ResignationLetterNested, AmendmentNested } from "@/features/hr/contracts/types";

export interface GroupedContract {
  contract: CombinedContractListItem;
  resignationLetters: ResignationLetterNested[];
  amendments: AmendmentNested[];
}

export function mapCombinedToGrouped(contracts: CombinedContractListItem[]): GroupedContract[] {
  return contracts.map((contract) => ({
    contract,
    resignationLetters: contract.resignation_letters,
    amendments: contract.amendments,
  }));
}
